import { watch } from 'vue'
import { useAuthStore } from '@/features/account/session'
import { useBotsStore } from '@/features/bots/store'

export function useBotsSession() {
  const auth = useAuthStore()
  const bots = useBotsStore()
  watch(() => auth.userId, id => bots.setAccount(id), { immediate: true, flush: 'sync' })
}
